module.exports = __webpack_public_path__ + "static/media/ic_amex.1f1a90a1.svg";